import { Twitter, Youtube } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "swiper/css";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../../firebase.init";

const Footer = () => {
  const [user] = useAuthState(auth);
  const [footerData, setFooterData] = useState({
    logo: { src: "", alt: "" },
    description: "",
    companyLinks: [],
    resourceLinks: [],
    newsletterTitle: "",
    newsletterPlaceholder: "",
    socialLinks: [],
    copyright: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          "https://demo-email-marketing-1-f6e91377e127.herokuapp.com/api/footer-section"
        );
        if (response.data.success) {
          setFooterData(response.data.data);
        } else {
          setError("Failed to fetch footer data");
        }
      } catch (err) {
        console.error("Error fetching footer data:", err);
        setError("Error fetching footer data");
      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  if (loading)
    return (
      <div>
        <div className="container py-5 text-center mt-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden"></span>
          </div>
        </div>
      </div>
    );
  if (error) return <div></div>;

  const getFilteredCompanyLinks = () => {
    if (!user) {
      return footerData.companyLinks;
    }

    return footerData.companyLinks.filter(
      (link) => link.text !== "Sign in" && link.text !== "Register"
    );
  };

  return (
    <>
      <footer className="main-footer">
        <div className="main-footer__shape-1 img-bounce" />
        <div className="main-footer__top">
          <div className="container">
            <div className="row">
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <div className="footer-widget__column footer-widget__about">
                  <div className="footer-widget__logo">
                    <a href="/">
                      <img
                        src={footerData.logo.src}
                        alt={footerData.logo.alt}
                      />
                    </a>
                  </div>
                  <p className="footer-widget__about-text">
                    {footerData.description}
                  </p>
                </div>
              </div>
              <div
                className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay="200ms"
              >
                <div className="footer-widget__column footer-widget__company">
                  <div className="footer-widget__title-box">
                    <h3 className="footer-widget__title">Links</h3>
                  </div>
                  <div className="footer-widget__company-list-box">
                    <ul className="footer-widget__company-list">
                      {getFilteredCompanyLinks().map((link) => (
                        <li key={link.id}>
                          <a href={link.url}>{link.text}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay="300ms"
              >
                <div className="footer-widget__column footer-widget__resources">
                  <div className="footer-widget__title-box">
                    <h3 className="footer-widget__title">Resources</h3>
                  </div>
                  <div className="footer-widget__resources-list-box">
                    <ul className="footer-widget__resources-list">
                      {footerData.resourceLinks.map((link) => (
                        <li key={link.id}>
                          <a href={link.url}>{link.text}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay="400ms"
              >
                <div className="footer-widget__column footer-widget__newsletter">
                  <div className="footer-widget__title-box">
                    <h3 className="footer-widget__title">
                      {footerData.newsletterTitle}
                    </h3>
                  </div>

                  <div className="site-footer__social">
                    {footerData.socialLinks.map((social) => (
                      <a key={social.id} href={social.url}>
                        <i className={social.icon} />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-footer__bottom">
          <div className="container">
            <div className="main-footer__bottom-inner">
              <p className="main-footer__bottom-text">{footerData.copyright}</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
